export const APP_VERSION = '2.19.0';
